import DataBinder from "../DataBinder.js"
import SwapPage from "../SwapPage.js"
export default class MainMenu {

	constructor(app) {
		this.app = app;
	}
	show(path, model) {
		model = this.getModel();

		//get page
		let pageId = "MainMenu";

		const dataBinder = new DataBinder();
		dataBinder.populate(pageId, model);

		const swapPage = new SwapPage();
		swapPage.swapPage(pageId);
	}
	getModel() {
		const app = this.app;
		const userdata = app.userdata;
		const config = app.config;
		console.log('config is', config, app);
		const device = app.device;
		const achievement = app.achievements;

		achievement.checkForAchievementAndReward(userdata);

		let achievementCount = (userdata.achievements ? userdata.achievements.length : 0);
		let achievementMax = achievement.allAchievements.length;
		let isTitleBroken = userdata.stats && userdata.stats.titleTapped >= 400;
		let showMoreGames = !config.hideMoreGames && !userdata.fullVersion;
		let showAppLinks = config.showAppLinks;
		let showAboutGame = !config.hideAboutGame;
		let showRateGame = !config.hideRateGame;

		const model = {
			version: config.version,
			os: config.OS,
			showAppLinks: showAppLinks,
			showMoreGames: showMoreGames,
			showAboutGame: showAboutGame,
			showRateGame: showRateGame,
			name: userdata.name,
			avatar: userdata.avatar,
			level: userdata.level,
			rank: userdata.rank,
			rating: userdata.rating,
			coins: userdata.coins,
			achievementCount: achievementCount,
			achievementMax: achievementMax,
			isRewardedAdReady: false,
			isRewardReady: false,
			isTitleBroken: isTitleBroken
		};

		return model;
	}
	rateGame() {
		this.app.rate();
	}
	tapOnTitle() {
		const app = this.app;
		if(!app.userdata.stats) app.userdata.stats = {};
		app.userdata.stats.titleTapped = (app.userdata.stats.titleTapped || 0) + 1;
		const achievement = app.achievements.checkForAchievementAndReward(app.userdata);
		if(achievement) {
			app.populate();

		}
	}
	promoCode() {
		if (!this.promoCodeClickCount) this.promoCodeClickCount = 0;
		this.promoCodeClickCount++;
		if (this.promoCodeClickCount >= 10) {
			this.app.navigate("Code");
		}

	}
	showRewardedAd() { }
	share() {
		this.app.share();
	}
	admin() {
		if (!this.adminCodeClickCount) this.adminCodeClickCount = 0;
		this.adminCodeClickCount++;
		if (this.adminCodeClickCount >= 10) {
			this.app.navigate("Admin");
		}

	}
	openMoreGameFB() {

	}

}
